import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=12cdade8&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/legal.less?vue&type=style&index=0&id=12cdade8&prod&scoped=true&lang=less&external"
import style1 from "./TermsOfService.vue?vue&type=style&index=1&id=12cdade8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cdade8",
  null
  
)

export default component.exports